// extracted by mini-css-extract-plugin
export var numpadContainer = "_nu-1";
export var phoneButton = "_nu-0";